/* BG COM 2nde vie : fiche machine d'occasion (sections/bgcom-occ-fiche.liquid). Reprise du prototype validé le 01/10/2026.
   - Demande : une fenêtre, plusieurs modes ([data-mf-open="mode"]), envoi par le formulaire de contact de la boutique.
     « E-mail OU téléphone » suffit : sans e-mail, l'adresse de la boutique sert d'expéditeur technique et l'objet le dit.
   - Galerie (piste défilante, compteur, vignettes, flèches, clavier), visionneuse, mur de photos.
   - Barre collante : en haut sur ordinateur (remplace l'en-tête du site quand le bouton principal sort de l'écran),
     en bas sur téléphone et tablette (cachée pendant une demande et au pied de page).
   - Imprimer : window.print() et la feuille d'impression de bgcom-occ-fiche.css. Télécharger : vrai PDF (jsPDF au clic, voir plus bas).
   Aucun ajout au panier, aucune donnée envoyée ailleurs que par le formulaire de contact. */
(function () {
  if (window.BGMF) return;
  window.BGMF = { v: 1 };
  var d = document;
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  function init() {
    var root = $('[data-mf]');
    if (!root) return;
    var html = d.documentElement;
    var mqDesk = window.matchMedia('(min-width: 1025px)');

    /* ---------- Hauteur de l'en-tête collant du site + gouttière (repères CSS) ---------- */
    function headerH() {
      var h = d.querySelector('.header-section.header-sticky');
      if (!h) return 0;
      var cs = getComputedStyle(h);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return 0;
      return Math.round(h.getBoundingClientRect().height);
    }
    function measure() {
      var hh = headerH();
      root.style.setProperty('--mf-hh', hh + 'px');
      html.style.setProperty('--mf-hh', hh + 'px');
      var top = $('.mf-top', root);
      if (top) root.style.setProperty('--mf-gut', (parseFloat(getComputedStyle(top).paddingLeft) || 20) + 'px');
    }
    measure();
    var rz;
    window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { measure(); upd(); }, 120); }, { passive: true });

    /* ---------- Fenêtre de demande ---------- */
    var dlg = $('[data-mf-dlg]', root), modes = {}, opener = null, refName = '';
    var form = dlg && $('form', dlg);
    var nameDefault = $('.mf-title__nm', root) ? $('.mf-title__nm', root).textContent.trim() : '';
    try { modes = JSON.parse($('[data-mf-modes]', dlg).textContent); } catch (e) { modes = {}; }
    function setMode(mode, keepMsg) {
      if (!dlg || !modes[mode]) return;
      var m = modes[mode];
      dlg.setAttribute('data-mode', mode);
      var t = $('[data-mf-title]', dlg); if (t) t.textContent = m.t;
      var ob = $('[data-mf-objet]', dlg); if (ob) { ob.value = m.o || ''; ob.setAttribute('data-base', ob.value); }
      var want = m.d || mode;
      $$('input[data-mode]', dlg).forEach(function (r) { r.checked = r.getAttribute('data-mode') === want; });
      var msg = $('#mf-f-msg', dlg);
      if (msg && !keepMsg && (!msg.value.trim() || msg.getAttribute('data-auto') === msg.value)) {
        msg.value = (m.m || '').replace('{machine}', refName || nameDefault);
        msg.setAttribute('data-auto', msg.value);
      }
    }
    function lockScroll(on) { html.style.overflow = on ? 'hidden' : ''; }
    function openDlg(mode, from) {
      if (!dlg) return false;
      opener = from || d.activeElement;
      refName = (from && from.getAttribute && from.getAttribute('data-mf-machine')) || '';
      var ml = $('[data-mf-mline]', dlg), ref = $('[data-mf-ref]', dlg);
      if (ml) ml.textContent = refName ? 'Machine de référence : ' + refName : ml.getAttribute('data-default');
      if (ref) { ref.value = refName; ref.disabled = !refName; }
      if (!$('[data-mf-ok]', dlg)) {
        var msg = $('#mf-f-msg', dlg);
        if (msg && msg.getAttribute('data-auto') === msg.value) msg.value = '';
        setMode(modes[mode] ? mode : (dlg.getAttribute('data-intent') || 'dossier'));
        var fe = $('[data-mf-ferr]', dlg); if (fe) fe.hidden = true;
        $$('[aria-invalid]', dlg).forEach(function (f) { f.removeAttribute('aria-invalid'); });
      }
      try { sessionStorage.setItem('mf-mode', mode); } catch (e) {}
      if (!dlg.open) {
        try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
        lockScroll(true);
        dlgOpen = true; upd();
      }
      var t = $('#mf-req-t', dlg);
      if (t) setTimeout(function () { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } }, 30);
      return true;
    }
    function validate() {
      var ct = $('#mf-f-ct', form), em = $('[data-mf-email]', form), ph = $('[data-mf-phone]', form), ob = $('[data-mf-objet]', form);
      var fe = $('[data-mf-ferr]', form);
      var v = ct ? ct.value.trim() : '';
      var isMail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v);
      var digits = v.replace(/\D/g, '');
      var err = '';
      if (!v) err = 'Indiquez un e-mail ou un numéro de téléphone.';
      else if (v.indexOf('@') > -1 && !isMail) err = "L'adresse e-mail semble incomplète.";
      else if (!isMail && digits.length < 6) err = 'Le numéro de téléphone semble incomplet.';
      if (err) {
        if (ct) { ct.setAttribute('aria-invalid', 'true'); ct.focus(); }
        if (fe) { fe.textContent = err; fe.hidden = false; }
        return false;
      }
      if (ct) ct.removeAttribute('aria-invalid');
      if (fe) fe.hidden = true;
      if (ob && ob.hasAttribute('data-base')) ob.value = ob.getAttribute('data-base');
      if (isMail) {
        em.value = v; ph.value = ''; ph.disabled = true;
      } else {
        em.value = dlg.getAttribute('data-shop-email') || '';
        ph.value = v; ph.disabled = false;
        if (ob) ob.value = (ob.value || 'Demande') + " (pas d'e-mail : rappeler au " + v + ')';
      }
      return true;
    }
    if (dlg) {
      $$('[data-mf-close]', dlg).forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
      dlg.addEventListener('click', function (e) {
        if (e.target !== dlg) return;
        var r = dlg.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dlg.close();
      });
      dlg.addEventListener('close', function () {
        lockScroll(false);
        dlgOpen = false; upd();
        if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
      });
      $$('input[data-mode]', dlg).forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) setMode(r.getAttribute('data-mode')); });
      });
      var msg = $('#mf-f-msg', dlg);
      if (msg) msg.addEventListener('input', function () { msg.removeAttribute('data-auto'); });
      /* phase de capture sur window : la vérification passe avant le contrôle anti-robot de Shopify (hCaptcha) ; une
         demande incomplète ne déclenche donc jamais ce contrôle */
      if (form) window.addEventListener('submit', function (e) {
        if (e.target !== form) return;
        if (!validate()) { e.preventDefault(); e.stopImmediatePropagation(); }
      }, true);
      window.BGMF.prep = validate;
    }
    d.addEventListener('click', function (e) {
      var o = e.target.closest && e.target.closest('[data-mf-open]');
      if (!o || !dlg) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
      e.preventDefault(); e.stopPropagation();
      openDlg(o.getAttribute('data-mf-open'), o);
    });

    /* ---------- Imprimer / PDF ---------- */
    $$('[data-mf-print]', root).forEach(function (b) { b.addEventListener('click', function () { window.print(); }); });

    /* ---------- Télécharger la fiche technique : vrai PDF construit dans le navigateur (04/10/2026) ----------
       Données : <script id="mf-pdf-data"> (machine.fiche + prix, photos, contact). jsPDF (cdnjs) et la police Poppins (jsDelivr,
       repli Helvetica) ne sont chargés qu'au premier clic. Une page A4 (deux si la fiche est longue) : bandeau BG COM 2nde vie,
       titre, photo, prix, chiffres clés, description, documents, blocs de la fiche en deux colonnes, pied de page avec le lien.
       Rien n'est envoyé nulle part ; sans fiche structurée ou en cas d'échec : la feuille d'impression (window.print). */
    var pdfData = null;
    try { pdfData = JSON.parse(($('#mf-pdf-data') || {}).textContent || 'null'); } catch (e) { pdfData = null; }
    var JSPDF = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
    var FONTS = { r: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/poppins/Poppins-Regular.ttf',
                  m: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/poppins/Poppins-Medium.ttf',
                  b: 'https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/poppins/Poppins-Bold.ttf' };
    var libP = null, fontP = null;
    function loadLib() {
      if (window.jspdf && window.jspdf.jsPDF) return Promise.resolve(window.jspdf.jsPDF);
      if (!libP) libP = new Promise(function (ok, ko) { var s = d.createElement('script'); s.src = JSPDF; s.async = true; s.onload = function () { window.jspdf ? ok(window.jspdf.jsPDF) : ko(); }; s.onerror = ko; d.head.appendChild(s); });
      return libP;
    }
    function b64(buf) { var b = new Uint8Array(buf), s = '', i, k = 0x8000; for (i = 0; i < b.length; i += k) s += String.fromCharCode.apply(null, b.subarray(i, i + k)); return btoa(s); }
    function loadFonts() {
      if (!fontP) fontP = Promise.all(['r', 'm', 'b'].map(function (k) { return fetch(FONTS[k]).then(function (r) { if (!r.ok) throw 0; return r.arrayBuffer(); }).then(b64); }))
        .then(function (a) { return { r: a[0], m: a[1], b: a[2] }; }).catch(function () { return null; });
      return fontP;
    }
    function abs(u) { return !u ? '' : u.indexOf('//') === 0 ? 'https:' + u : u; }
    function loadImg(url, box) { /* box = rapport largeur/hauteur voulu (recadrage « cover ») ou 0 pour garder l'image entière */
      return new Promise(function (ok) {
        if (!url) return ok(null);
        var im = new Image(); im.crossOrigin = 'anonymous';
        im.onload = function () {
          try {
            var sw = im.naturalWidth, sh = im.naturalHeight, sx = 0, sy = 0;
            if (box) { if (sw / sh > box) { sx = (sw - sh * box) / 2; sw = sh * box; } else { sy = (sh - sw / box) / 2; sh = sw / box; } }
            var k = Math.min(1, 1400 / sw), c = d.createElement('canvas'); c.width = Math.round(sw * k); c.height = Math.round(sh * k);
            var x = c.getContext('2d'); if (box) { x.fillStyle = '#fff'; x.fillRect(0, 0, c.width, c.height); }
            x.drawImage(im, sx, sy, sw, sh, 0, 0, c.width, c.height);
            ok({ d: c.toDataURL(box ? 'image/jpeg' : 'image/png', 0.86), w: c.width, h: c.height, f: box ? 'JPEG' : 'PNG' });
          } catch (e) { ok(null); }
        };
        im.onerror = function () { ok(null); };
        im.src = abs(url);
      });
    }
    function txt(s, uni, keep) { /* entités HTML, balises, tirets longs ; sans Poppins : seulement l'alphabet WinAnsi ; keep = garder les espaces des bords */
      var t = d.createElement('textarea'); t.innerHTML = String(s == null ? '' : s).replace(/<[^>]*>/g, ' '); s = t.value.replace(/—/g, '–').replace(/\s+/g, function (m) { return m.indexOf(' ') > -1 && m.length === 1 ? m : ' '; });
      if (!keep) s = s.trim();
      if (!uni) s = s.replace(/[  ]/g, ' ').replace(/[‘’]/g, "'").replace(/[“”]/g, '"').replace(/[^\x20-\x7e -ÿ–—€•…Œœ]/g, '');
      return s;
    }

    function buildPdf(JsPDF, F, logo, photo, Z) {
      Z = Z || 1;
      var D = pdfData, fi = D.fiche || {}, uni = !!F;
      var doc = new JsPDF({ unit: 'mm', format: 'a4', compress: true });
      var FN = uni ? 'Poppins' : 'helvetica';
      if (uni) {
        doc.addFileToVFS('P-R.ttf', F.r); doc.addFont('P-R.ttf', 'Poppins', 'normal');
        doc.addFileToVFS('P-B.ttf', F.b); doc.addFont('P-B.ttf', 'Poppins', 'bold');
        doc.addFileToVFS('P-M.ttf', F.m); doc.addFont('P-M.ttf', 'PoppinsM', 'normal');
      }
      var W = 210, H = 297, M = 14, CW = W - 2 * M, BOT = H - 18;
      var INK = [23, 23, 23], GREY = [92, 92, 92], MUTE = [138, 138, 138], RED = [225, 6, 0], RULE = [226, 226, 226], BAND = [241, 241, 242];
      function f(w, size, col) { doc.setFont(w === 'm' ? (uni ? 'PoppinsM' : 'helvetica') : FN, w === 'b' ? 'bold' : 'normal'); doc.setFontSize(size < 12 ? size * Z : size); doc.setTextColor.apply(doc, col || INK); }
      function T(s, keep) { return txt(s, uni, keep); }
      function lines(s, w) { return doc.splitTextToSize(T(s), w); }
      function LH(size, k) { return (size < 12 ? size * Z : size) * 0.3528 * (k || 1.45); }
      var page = 1, sold = D.status === 'vendu';

      function header(first) {
        doc.setFillColor(14, 14, 15); doc.rect(0, 0, W, first ? 24 : 14, 'F');
        var hh = first ? 24 : 14, lh = first ? 8.5 : 6;
        if (logo) { var lw = lh * logo.w / logo.h; doc.addImage(logo.d, 'PNG', M, (hh - lh) / 2, lw, lh); f('b', first ? 7.5 : 6.5, RED); doc.text('2NDE VIE', M + lw + 5, hh / 2 + 1.2, { charSpace: 0.8 }); }
        else { f('b', 11, [255, 255, 255]); doc.text('BG COM AGENCY', M, hh / 2 + 1.5); }
        f('m', first ? 9 : 7.5, [255, 255, 255]); doc.text(T(D.phone), W - M, first ? 11 : 8.4, { align: 'right' });
        if (first) { f('r', 7.5, [170, 170, 170]); doc.text(T(D.domain), W - M, 15.6, { align: 'right' }); }
        return hh;
      }
      function newPage() { doc.addPage(); page++; return header(false) + 8; }

      /* ---- page 1 : titre, photo, prix ---- */
      var y = header(true) + 9;
      var colL = photo ? 98 : CW, px = M + colL + 6, pw = W - M - px, ph = photo ? pw / (Z < 1 ? 1.5 : 1.33) : 0;
      f('m', 9, GREY); var fl = lines(fi.famille || D.fam, colL); doc.text(fl, M, y); y += fl.length * LH(9);
      f('b', 20, INK); var tl = lines(fi.titre_court || D.nm, colL); y += 3.2; doc.text(tl, M, y + 4); y += 4 + (tl.length - 1) * LH(20, 1.15) + 2;
      if (fi.sous_titre || D.sub) { f('r', 9, GREY); var sl = lines(fi.sous_titre || D.sub, colL); y += 3; doc.text(sl, M, y); y += sl.length * LH(9); }
      y += 5;
      if (sold) {
        f('b', 11, RED); doc.setDrawColor.apply(doc, RED); doc.setLineWidth(0.5); var vw = doc.getTextWidth('VENDU') + 8; doc.roundedRect(M, y - 5, vw, 8, 1.2, 1.2, 'S'); doc.text('VENDU', M + 4, y + 0.6, { charSpace: 0.6 });
        f('r', 8.5, GREY); doc.text(T('Machine vendue, fiche conservée pour référence.'), M + vw + 4, y + 0.2); y += 8;
      } else if (D.price) {
        f('b', 15, INK); doc.text(T(D.price), M, y + 1); y += 5;
        if (D.tax) { f('r', 8, GREY); var xl = lines(D.tax, colL); doc.text(xl, M, y + 1.5); y += xl.length * LH(8) + 1; }
      }
      if (photo) { doc.addImage(photo.d, 'JPEG', px, 33, pw, ph); doc.setDrawColor.apply(doc, RULE); doc.setLineWidth(0.2); doc.rect(px, 33, pw, ph, 'S'); }
      y = Math.max(y + 4, photo ? 33 + ph + 6 : y + 4);

      /* ---- chiffres clés ---- */
      var ch = (fi.chiffres || []).slice(0, 6);
      if (ch.length) {
        var cw = CW / ch.length;
        doc.setDrawColor.apply(doc, INK); doc.setLineWidth(0.5); doc.line(M, y, W - M, y);
        var rowH = 0;
        ch.forEach(function (c, i) {
          var x = M + i * cw + (i ? 3 : 0), w = cw - (i ? 6 : 3);
          f('m', 7, MUTE); var lb = lines(String(c.label || '').toUpperCase(), w); doc.text(lb, x, y + 5.2, { charSpace: 0.2 });
          f('b', 10.5, INK); var vl = lines(String(c.valeur || '').replace(/\*\*/g, ''), w); doc.text(vl, x, y + 5.2 + lb.length * LH(7) + 3.2);
          rowH = Math.max(rowH, 5.2 + lb.length * LH(7) + 3.2 + (vl.length - 1) * LH(10.5) + 4);
          if (i) { doc.setDrawColor.apply(doc, RULE); doc.setLineWidth(0.2); doc.line(M + i * cw, y + 2.5, M + i * cw, y + rowH - 1.5); }
        });
        y += rowH; doc.setDrawColor.apply(doc, RULE); doc.setLineWidth(0.2); doc.line(M, y, W - M, y); y += 7;
      }

      /* ---- description (+ documents) ---- */
      var desc = (fi.description || []).filter(Boolean);
      function h2(s, x, yy, num) { if (num) { f('b', 8.5, RED); doc.text(String(num), x, yy); x += doc.getTextWidth(String(num)) + 2.2; } f('b', 11, INK); doc.text(T(s), x, yy); }
      if (desc.length) {
        if (y > BOT - 30) y = newPage();
        h2('Description', M, y); y += 6;
        f('r', 9, INK);
        desc.forEach(function (p) { var pl = lines(String(p).replace(/\*\*/g, ''), CW); if (y + pl.length * LH(9) > BOT) y = newPage(); doc.text(pl, M, y); y += pl.length * LH(9) + 2.2; });
        y += 1;
      }
      if ((fi.dossier || []).length) {
        var items = fi.dossier.map(function (t) { f('r', 8.5); return lines(t, CW - 16); });
        var bh = 13 + items.reduce(function (a, l) { return a + l.length * LH(8.5) + 1.2; }, 0) + (fi.dossier_intro ? LH(8.5) : 0);
        if (y + bh > BOT) y = newPage();
        doc.setFillColor.apply(doc, BAND); doc.roundedRect(M, y, CW, bh, 2, 2, 'F');
        var yy = y + 7; f('b', 9.5, INK); doc.text(T(fi.dossier_titre || 'Le dossier technique'), M + 6, yy);
        if (fi.dossier_intro) { f('r', 8.5, GREY); yy += 5; doc.text(T(fi.dossier_intro), M + 6, yy); }
        yy += 5.5; f('r', 8.5, INK);
        items.forEach(function (l) { doc.setDrawColor.apply(doc, INK); doc.setLineWidth(0.35); doc.line(M + 6.6, yy - 1.2, M + 7.6, yy - 0.2); doc.line(M + 7.6, yy - 0.2, M + 9.4, yy - 2.4); doc.text(l, M + 11.5, yy); yy += l.length * LH(8.5) + 1.2; });
        y += bh + 7;
      }

      /* ---- blocs de la fiche, deux colonnes (chaque bloc va dans la colonne la plus courte, jamais coupé) ---- */
      var gs = (fi.groupes || []).filter(function (g) { return (g.lignes && g.lignes.length) || (g.items && g.items.length); });
      var GW = (CW - 8) / 2, LW = GW * 0.42;
      function valRuns(v, x, yy, w, draw) { /* « **gras** » : en une ligne si possible, sinon texte simple sur plusieurs lignes */
        var parts = String(v || '').split('**'), wsum = 0;
        parts.forEach(function (p, i) { f(i % 2 ? 'b' : 'r', 8.5); wsum += doc.getTextWidth(T(p, true)); });
        if (wsum <= w) { if (draw) { var cx = x; parts.forEach(function (p, i) { if (!p) return; f(i % 2 ? 'b' : 'r', 8.5, INK); doc.text(T(p, true), cx, yy); cx += doc.getTextWidth(T(p, true)); }); } return 1; }
        f(/^\*\*.*\*\*$/.test(String(v)) ? 'b' : 'r', 8.5, INK); var vl = lines(String(v).replace(/\*\*/g, ''), w); if (draw) doc.text(vl, x, yy); return vl.length;
      }
      function group(g, x, y0, draw) {
        var yy = y0;
        if (draw) { h2(g.titre || '', x, yy + 3.5, g.num); doc.setDrawColor.apply(doc, INK); doc.setLineWidth(0.45); doc.line(x, yy + 6, x + GW, yy + 6); }
        yy += 7.5 + 3 * Z;
        if (g.items && g.items.length) {
          [true, false].forEach(function (inc) {
            var its = g.items.filter(function (it) { return !!it.inclus === inc; }); if (!its.length) return;
            f('b', 8, INK); if (draw) doc.text(inc ? 'Inclus dans la vente' : 'Non compris', x, yy); yy += 4.6;
            its.forEach(function (it) {
              f('r', 8.5, inc ? INK : GREY); var tl2 = lines(it.texte, GW - 6);
              if (draw) { doc.setDrawColor.apply(doc, inc ? INK : MUTE); doc.setLineWidth(0.35); if (inc) { doc.line(x + 0.3, yy - 1.2, x + 1.3, yy - 0.2); doc.line(x + 1.3, yy - 0.2, x + 3.1, yy - 2.4); } else doc.line(x + 0.3, yy - 1.2, x + 3.1, yy - 1.2); doc.text(tl2, x + 5.5, yy); }
              yy += tl2.length * LH(8.5);
              if (it.note) { f('r', 7.5, MUTE); var nl = lines(it.note, GW - 6); if (draw) doc.text(nl, x + 5.5, yy); yy += nl.length * LH(7.5); }
              yy += 1.6; if (draw) { doc.setDrawColor.apply(doc, RULE); doc.setLineWidth(0.15); doc.line(x, yy - 1.7, x + GW, yy - 1.7); } yy += 1.2;
            });
            yy += 1.5;
          });
        } else {
          (g.lignes || []).forEach(function (l) {
            f('r', 8, GREY); var ll = lines(l.label, LW - 3); if (draw) doc.text(ll, x, yy);
            var n = valRuns(l.valeur, x + LW, yy, GW - LW, draw), hgt = Math.max(ll.length * LH(8), n * LH(8.5));
            if (l.note) { f('r', 7.5, MUTE); var nl2 = lines(l.note, GW - LW); if (draw) doc.text(nl2, x + LW, yy + n * LH(8.5)); hgt = Math.max(hgt, n * LH(8.5) + nl2.length * LH(7.5)); }
            if (l.liste && l.liste.length) { f('r', 7.8, INK); l.liste.forEach(function (it, k) { var il = lines((k + 1) + '. ' + it, GW - LW); if (draw) doc.text(il, x + LW, yy + hgt); hgt += il.length * LH(7.8); }); }
            yy += hgt + 1.4 * Z; if (draw) { doc.setDrawColor.apply(doc, RULE); doc.setLineWidth(0.15); doc.line(x, yy - 1.6 * Z, x + GW, yy - 1.6 * Z); } yy += 1.6 * Z;
          });
        }
        return yy - y0 + 4 * Z;
      }
      if (gs.length) {
        if (y > BOT - 40) y = newPage();
        var top = y, cy = [y, y], cx = [M, M + GW + 8];
        gs.forEach(function (g) {
          var hgt = group(g, 0, 0, false), c = cy[0] <= cy[1] ? 0 : 1;
          if (cy[c] + hgt > BOT) { var o = 1 - c; if (cy[o] + hgt <= BOT) c = o; else { top = newPage(); cy = [top, top]; c = 0; } }
          group(g, cx[c], cy[c], true); cy[c] += hgt;
        });
      }

      /* ---- pied de page (toutes les pages) ---- */
      var n = doc.getNumberOfPages(), today = new Date(), dd = ('0' + today.getDate()).slice(-2) + '/' + ('0' + (today.getMonth() + 1)).slice(-2) + '/' + today.getFullYear();
      for (var i = 1; i <= n; i++) {
        doc.setPage(i);
        doc.setDrawColor.apply(doc, RULE); doc.setLineWidth(0.2); doc.line(M, H - 12.5, W - M, H - 12.5);
        var right = 'Fiche du ' + dd + (n > 1 ? ' · ' + i + '/' + n : '');
        f('r', 7, MUTE); doc.text(right, W - M, H - 8, { align: 'right' });
        f('b', 7.5, INK); doc.text('BG COM Agency · 2nde vie', M, H - 8);
        var lx = M + doc.getTextWidth('BG COM Agency · 2nde vie') + 3; f('r', 7.5, GREY);
        doc.text(T(D.phone) + ' · ' + T(D.domain), lx, H - 8);
        if (!sold && D.tax) { f('r', 6.8, MUTE); doc.text(T(D.tax), W - M, H - 4.2, { align: 'right' }); }
        f('m', 7, RED); doc.textWithLink(T('Voir la machine et ses photos en ligne'), M, H - 4.2, { url: D.url });
      }
      doc.setProperties({ title: T((fi.titre_court || D.nm) + ' · fiche technique'), author: 'BG COM Agency', subject: T(fi.famille || D.fam), creator: 'bgcomagency.com' });
      var slug = String(fi.titre_court || D.handle || 'machine').normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^A-Za-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60);
      return { doc: doc, name: 'BG-COM-2nde-vie_' + slug + '_fiche-technique.pdf' };
    }
    function makePdf(JsPDF, F, logo, photo) { /* tient sur UNE page si possible : on resserre (texte et interlignes) jusqu'à 2 fois */
      var best = null;
      [1, 0.9, 0.82].some(function (z) { var r = buildPdf(JsPDF, F, logo, photo, z), n = r.doc.getNumberOfPages(); if (!best || n < best.n) best = { r: r, n: n }; return n === 1; });
      best.r.doc.save(best.r.name);
    }

    $$('[data-mf-pdf]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!pdfData || !pdfData.fiche) { window.print(); return; }
        if (b.classList.contains('is-busy')) return;
        b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true');
        var lab = b.querySelector('.mf-dl__t b, .mf-dl__l') || b, keep = lab.textContent; lab.textContent = 'Préparation du PDF…';
        var ph = (pdfData.imgs || [])[0];
        Promise.all([loadLib(), loadFonts(), loadImg(pdfData.logo, 0), loadImg(ph, 1.33)])
          .then(function (r) { makePdf(r[0], r[1], r[2], r[3]); })
          .catch(function () { window.print(); })
          .then(function () { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); lab.textContent = keep; });
      });
    });

    /* ---------- Galerie ---------- */
    var photos = [];
    try { photos = JSON.parse(($('[data-mf-photos]', root) || {}).textContent || '[]'); } catch (e) { photos = []; }
    var track = $('[data-mf-track]', root), curEl = $('[data-mf-cur]', root), cur = 0;
    function idx() { return track && track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
    function go(i) {
      if (!track) return;
      i = Math.max(0, Math.min(photos.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    if (track) {
      track.addEventListener('scroll', function () {
        var i = idx();
        if (i === cur) return;
        cur = i;
        if (curEl) curEl.textContent = i + 1;
        $$('[data-mf-th]', root).forEach(function (b) { b.setAttribute('aria-current', +b.getAttribute('data-mf-th') === i ? 'true' : 'false'); });
      }, { passive: true });
      var pv = $('[data-mf-prev]', root), nx = $('[data-mf-next]', root);
      if (pv) pv.addEventListener('click', function () { go(idx() - 1); });
      if (nx) nx.addEventListener('click', function () { go(idx() + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx() - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx() + 1); }
        if (e.key === 'Enter') { e.preventDefault(); openLb(idx()); }
      });
      $$('.mf-slide', track).forEach(function (s) {
        s.addEventListener('click', function () { if (photos.length) openLb(+s.getAttribute('data-i')); });
      });
    }
    $$('[data-mf-th]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = +b.getAttribute('data-mf-th');
        if (b.hasAttribute('data-mf-more')) { openLb(i); return; }
        go(i);
      });
    });

    /* ---------- Visionneuse ---------- */
    var lb = $('[data-mf-lbdlg]', root), li = 0;
    function show(i) {
      if (!photos.length || !lb) return;
      li = (i + photos.length) % photos.length;
      var p = photos[li], im = $('[data-mf-lbimg]', lb);
      im.src = p.src; im.alt = p.alt || '';
      var cap = $('[data-mf-lbcap]', lb);
      if (cap) cap.textContent = 'Photo ' + (li + 1) + ' / ' + photos.length;
    }
    function openLb(i) {
      if (!lb || !photos.length) return;
      opener = d.activeElement;
      show(i || 0);
      try { lb.showModal(); } catch (e) { lb.setAttribute('open', ''); }
      lockScroll(true); dlgOpen = true; upd();
    }
    if (lb) {
      var lp = $('[data-mf-lprev]', lb), ln = $('[data-mf-lnext]', lb);
      if (lp) lp.addEventListener('click', function () { show(li - 1); });
      if (ln) ln.addEventListener('click', function () { show(li + 1); });
      $$('[data-mf-close]', lb).forEach(function (b) { b.addEventListener('click', function () { lb.close(); }); });
      lb.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') show(li - 1);
        if (e.key === 'ArrowRight') show(li + 1);
      });
      lb.addEventListener('click', function (e) { if (e.target === lb) lb.close(); });
      var sx = null;
      lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) show(li + (dx < 0 ? 1 : -1));
      });
      lb.addEventListener('close', function () {
        lockScroll(false); dlgOpen = false; upd();
        go(li);
        if (opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (e) {} }
      });
    }
    $$('[data-mf-wall]', root).forEach(function (f) {
      function op() { openLb(+f.getAttribute('data-mf-wall')); }
      f.addEventListener('click', op);
      f.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); op(); } });
    });
    $$('[data-mf-lb]', root).forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var v = b.getAttribute('data-mf-lb');
        openLb(v === 'cur' ? idx() : +v);
      });
    });

    /* ---------- Barres collantes ---------- */
    var topbar = $('[data-mf-topbar]', root), mbar = $('[data-mf-mbar]', root), cta = $('[data-mf-main]', root);
    var past = false, dlgOpen = false, footOn = false;
    function ctaAbove() { if (!cta) return false; var r = cta.getBoundingClientRect(); return r.bottom < 0; }
    function upd() {
      var desk = mqDesk.matches;
      if (topbar) {
        var on = desk && past && !dlgOpen;
        if (on !== topbar.classList.contains('is-on')) {
          topbar.classList.toggle('is-on', on);
          topbar.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (on) topbar.removeAttribute('inert'); else topbar.setAttribute('inert', '');
        }
        html.classList.toggle('mf-tb-on', on);
        html.classList.toggle('mf-tb-off', !on);
      }
      if (mbar) {
        var mon = !desk && !dlgOpen && !footOn;
        mbar.classList.toggle('is-off', !mon);
        if (mon) mbar.removeAttribute('inert'); else mbar.setAttribute('inert', '');
      }
    }
    var foot = d.querySelector('.shopify-section-group-footer-group, footer');
    if (foot && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (en) { footOn = en.isIntersecting; }); upd(); }).observe(foot);
    }
    var links = topbar ? $$('.mf-topbar__nav a', topbar) : [];
    var secs = links.map(function (a) { return d.getElementById(a.getAttribute('href').slice(1)); });
    var tick = 0;
    function onScroll() {
      cancelAnimationFrame(tick);
      tick = requestAnimationFrame(function () {
        var p = ctaAbove();
        if (p !== past) { past = p; upd(); }
        if (topbar && topbar.classList.contains('is-on')) {
          var k = -1, y = 140;
          secs.forEach(function (s, i) { if (s && s.getBoundingClientRect().top < y) k = i; });
          links.forEach(function (a, i) { a.classList.toggle('is-cur', i === k); });
        }
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (mqDesk.addEventListener) mqDesk.addEventListener('change', upd);
    past = ctaAbove(); upd();

    /* ---------- Retour du formulaire (merci / erreurs) ou lien direct #dossier, #visite, #alerte… ---------- */
    if (dlg) {
      var last = dlg.getAttribute('data-intent') || 'dossier';
      try { last = sessionStorage.getItem('mf-mode') || last; } catch (e) {}
      if ($('[data-mf-ok]', dlg) || $('[data-mf-errors]', dlg)) {
        openDlg(last);
      } else {
        var h = (location.hash || '').replace('#', '');
        if (h && modes[h]) openDlg(h);
      }
    }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
})();
